import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';

/**
 * Trigger a browser download for a pre-constructed Blob. Routes the DOM
 * side effect through `FileDownloadService` so mock builds can suppress
 * it without any file leaving the app.
 */
export const saveBlobToDiskThunk = createAppAsyncThunk(
  'files/saveBlobToDisk',
  (
    { blob, filename }: { blob: Blob; filename: string },
    { extra: { pocServices } }
  ) => {
    pocServices.fileDownloadService.saveBlob(blob, filename);
  }
);
